import { jwtDecode } from "jwt-decode";
import { getRoleIdFromToken } from "./getRoleIdFromToken";
import { ROUTES } from "../constants/frontendPaths";

export const Logindata = (response, navigate) => {
 sessionStorage.setItem("User", JSON.stringify(response.data)); 
 sessionStorage.setItem("PartnerId", JSON.stringify(response.data.partnerId));
 sessionStorage.setItem("FacilitatorId", JSON.stringify(response.data.facilitatorId));

 sessionStorage.setItem("Token", JSON.stringify(response.data.jwtToken));

  
  const token  = response.data.jwtToken
  let decodedToken = jwtDecode(token);

  if(decodedToken.apiKey){

    const apiKey = (decodedToken.apiKey) 

    const APIKeyValue = apiKey.slice(0, -4);
  
    const IvKeyValue = apiKey.slice(0, -16);
   sessionStorage.setItem("ApiKey", JSON.stringify(apiKey));
   sessionStorage.setItem("SecurityKey", JSON.stringify(APIKeyValue));
  
   sessionStorage.setItem("IvKey", JSON.stringify(IvKeyValue));
  

  }
 


 sessionStorage.setItem("IsEncryption", JSON.stringify(response.data.isEncryption));
 sessionStorage.setItem("StepFlag", JSON.stringify(response.data.stepFlag));
 sessionStorage.setItem("roleId", JSON.stringify(response.data.roleId));
 sessionStorage.setItem("PartnerLogo", response.data.logoURL);
 sessionStorage.setItem("Env",JSON.stringify(response.data.env));
 sessionStorage.setItem(
    "PartnerPaymentRole",
    JSON.stringify(response.data.partnerRole)
  );
 sessionStorage.setItem(
    "OnboardingStatus",   
    JSON.stringify(response.data.onboardingStatus)
  );
 sessionStorage.setItem("IsFacilitator", response.data.isfacilitator);
  if (response.data.partnerId === null || response.data.partnerId === 0) {
   sessionStorage.setItem("StepFlag", "0");
    navigate(`/details`);
  } else if (
    (response.data.stepFlag === 5 && response.data.onboardingStatus === 2) ||
    (response.data.stepFlag === 5 && response.data.onboardingStatus === 5) ||
    (response.data.stepFlag === 5 && response.data.onboardingStatus === 4) ||
    (response.data.stepFlag === 11 && response.data.onboardingStatus === 7) ||
    (response.data.stepFlag === 4 && response.data.onboardingStatus === 3)
  ) {
    navigate(`/onboarding`);
  }
  else if(( response.data.roleId === 6   &&  response.data.roleId === 2
    
     && response.data.complianceExternal === 'Y' && response.data.excompliancecheck === 1 )|| response.data.complianceExternal === 'N'|| response.data.complianceExternal === 'Y'
  ) 
    {
      navigate(`/admin/compliance`);
    }
  
  
  else if (
    response.data.stepFlag === 11 &&
    response.data.onboardingStatus === 8
    
    // && response.data.externalcompliance !== 'Y' && response.data.excompliancecheck !== 0
    // && 
    // response.data.roleId !== 6
    
      
      
    
  ) 
//  if (  
  
// (  
//   // response.data.externalcompliance === 'Y' && response.data.excompliancecheck === 1) || (response.data.complianceExternal === 'N')
//   //  response.data.roleId !== '6')

//  )
  {
    navigate(`/dashboard`);
  } 

  
  
  else if (
    response.data.stepFlag <= 5 &&
    (response.data.onboardingStatus === 0 ||
      response.data.onboardingStatus === 1)
  ) {
    navigate(`/details`);
  } else if (
    response.data.stepFlag >= 6 &&
    response.data.onboardingStatus === 6
  ) {
    navigate(`/payment`);
  }

  

};

export const LogoClick = (partnerId, stepflag, status, navigate, roleId) => {
  if (partnerId === null || partnerId === 0) {
   sessionStorage.setItem("StepFlag", "0");
    navigate(`/details`);
  } else if (
    (stepflag === 5 && status === 2) ||
    (stepflag === 5 && status === 5) ||
    (stepflag === 5 && status === 4) ||
    (stepflag === 11 && status === 7)
  ) {
    navigate(`/onboarding`);
  } else if (stepflag === 11 && status === 8 ) {
    navigate(`/dashboard`);
  } else if (stepflag <= 5 && (status === 0 || status === 1 || status === 3)) {
    navigate(`/details`);
  } else if (stepflag >= 6 && status === 6) {
    navigate(`/payment`);
  }

  else if(roleId=== 6)

    // else if(roleId=== 6 && 
    // response.data.externalcompliance === 'Y' && response.data.excompliancecheck === 1  || response.data.externalcompliance === 'N')

  {
    navigate(`/admin/compliance`);
  }
};

export const Logout = (navigate) => {
  const token = sessionStorage.getItem("Token");
  const RoleId = getRoleIdFromToken(token);
  if (RoleId == 8 || RoleId == 9) {
    navigate(ROUTES.invoiceLogin);
  } else {
    navigate("/");
  }
  localStorage.clear();
  sessionStorage.clear();
};

export const Errordata = (error, toast, navigate) => {
  if (error.response === null || error.response === undefined) {
    toast.current?.show({
      severity: "error",
      summary: "These are returned when an internal server error occurs. Check dev portal for any maintenance in progress or reach out to techsupport@instarails.io",
      life: 3000,
    });
  } else if (error.response.status === 400) {
    toast.current?.show({
      severity: "error",
      summary: error.response.data[0].errorMessage,
      life: 3000,
    });
  } else if (error.response.status === 401) {
    toast.current?.show({
      severity: "error",
      summary: "Unauthorized",
      life: 3000,
    });
    Logout(navigate);
  } else {
    toast.current?.show({
      severity: "error",
      summary: "These are returned when an internal server error occurs. Check dev portal for any maintenance in progress or reach out to techsupport@instarails.io",
      life: 3000,
    });
  }
};

export const IsValidRoute = (navigate) => {
  const stepFlag = parseInt(sessionStorage.getItem("StepFlag"));
  const onboardingStatus = parseInt(sessionStorage.getItem("OnboardingStatus"));

  if (
    (stepFlag === 1 || stepFlag === 2 || stepFlag === 3 || stepFlag === 4) &&
    onboardingStatus === 1
  ) {
    navigate("/details");
  }
  if (stepFlag === 5 && (onboardingStatus === 2 || onboardingStatus === 5)) {
    navigate("/onboarding");
  }
  if (
    (stepFlag === 5 && onboardingStatus === 4) ||
    ((stepFlag === 6 ||
      stepFlag === 7 ||
      stepFlag === 8 ||
      stepFlag === 9 ||
      stepFlag === 10) &&
      onboardingStatus === 6)
  ) {
    navigate("/payment");
  }
};

